<script setup>
import { Link } from '@inertiajs/vue3'
import { Button } from '@/Components/ui/button'
import { ChevronRight } from 'lucide-vue-next'
import { tutors, howItWorks } from '@/routes/index'
</script>

<template>
  <section class="section pb-10 md:pb-12">
    <div class="container-page">
      <h1 class="max-w-[16ch] text-[clamp(2.1rem,1.1rem+4.2vw,4rem)] leading-[1.06]">
        Tutors who’ve proven they know how to succeed
        <span class="text-brand">academically.</span>
      </h1>

      <p class="mt-5 max-w-[56ch] text-lg leading-relaxed text-muted md:text-xl">
        Elite university tutors. Proven academic achievers. Personalised online tutoring that gets results.
      </p>

      <div class="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link :href="tutors()">
          <Button size="lg" class="w-full sm:w-auto">Find your tutor</Button>
        </Link>
        <!-- A page, not a jump link. This used to scroll a few hundred pixels
             to the offer comparison, which is not what the label promises. -->
        <Link :href="howItWorks()">
          <Button variant="secondary" size="lg" class="w-full sm:w-auto">
            How it works <ChevronRight class="size-4" />
          </Button>
        </Link>
      </div>
    </div>
  </section>
</template>
